import React from "react";
import './Curriculum.css';

export default function Curriculum() {
    return (
        <div className='Curriculum'>
            <h1 className='Titulo'>Curriculum Vitae</h1>
            <br />
            <h2>Rafael Merino Orea</h2>
            <br />
            Nace Ciudad de México, 03 de agosto 1947
            <br />
            <br />
            <div className='Parrafo'>Es considerado actualmente uno de los pinceles más exactos en cuanto a la definición del cuerpo humano, así mismo cuanta con un estilo simbólico y gran sensibilidad, Merino logra plasmar en cada una de sus obras, temas que enaltecen el arte pictórico y las cuales son de gran aceptación para el público en general. Conocedores del arte ha señalado a Merino Orea como un artista completo y entregado a su pasión, y gracias al dominio que tiene del color, sus pinturas en acrílico sobre tela los han llevado a presentarse consecutivamente de forma individual y colectiva dentro y fuera de la republica Mexicana, mismas que son vendidas a través del Consejo Nacional para la Cultura y las Artes A través del Instituto Nacional de Bellas Artes.
                Para el Museo Adolfo López Mateos es trascendental ser sede de esta exposición del Maestro Rafael Merinoo y permitir que la comunidad en general aprecie el trabajo de un artista mexicano reconocido entre un selecto grupo de artistas de la plástica mexicana, caracterizado por su exquisito gusto para plasmar emociones sobre tela en sus pinturas, un artista completo que ha presentado en México y en el extranjero más de cien exposiciones , a realizado trabajos especiales para casas editoras de libros, como son Editorial novara, editormex mexicana, novedades editores, sociedades bíblicas unidas, editorial herrero. Editorial posada, banco del atlántico, entres otras; y algunas de sus pinturas han sido plasmadas en los billetes de la Lotería Nacional.
                <br />
            </div>
            <br />
            <div className='Incisos'>
                <br />
                <h3>Formación</h3>
                <br />
                <ul>
                    <li>1964-1968 Becado en el Instituto de Arte de México con el profesor Guati Rojo (dibujo, pintura e historia del arte)</li>
                    <li>1976. Taller de Pintura con el Prof. G. Acevedo Navarro (dibujo)</li>
                    <li>1979. Taller de Escultura con el Prof... Saúl Moreno</li>
                    <li>1992. Taller de la Gráfica Popular con el Prof. Mereles (grabado)</li>
                    <li>1997-1998 Academia de San Carlos UNAM con el Prof. Marco Aurelio Prado (dibujo y pintura)</li>
                </ul>
            </div>

            <div className='Incisos'>
                <br />
                <h3>Exposiciones Individuales</h3>
                <br />
                <ul>
                    <li>1982 Universidad Nacional ENEP Aragón, México, D.F.</li>
                    <li>1982 Casa de la Cultura del Periodista, México, D.F.</li>
                    <li>1983 Club de Tabachines, Cuernavaca Morelos, México</li>
                    <li>1984 Galería Balance, México D.F.</li>
                    <li>1985 Casa de la Cultura del Periodista, México D.F.</li>
                    <li>1988 The Salon Fine Arts, Houston, Texas, USA</li>
                    <li>1989 Lotería Nacional, México D.F.</li>
                    <li>1990 Galería Artdicre. México D.F.</li>
                    <li>1990 Entrevista para televisión “ECO”</li>
                    <li>1991 Publicación de obra pictórica en billetes de la Lotería Nacional.</li>
                    <li>1992 Museo Venustiano Carranza, México D.F.</li>
                </ul>
            </div>
            <div className='Incisos'>
                <br />
                <h3>Galería</h3>
                <br />
                <ul>
                    <li>1992 Universidad Nacional ENEP Acatlán. Estado de México</li>
                    <li>1993 Centro Asturiano. México, D.F.</li>
                    <li>1993 Centro Cultural Ágora, Parque Naucalli Naucalpan, Estado de México</li>
                    <li>1993 Refinería Miguel Hidalgo. Tula Hidalgo México</li>
                    <li>1993 Colegio Americano, México, D.F.</li>
                    <li>1993 Publicación de obra pictórica en billetes de la Lotería Nacional</li>
                    <li>1994 Instituto Mexicano del Petróleo, México D.F.</li>
                    <li>1994 Centro de Convenciones, Acapulco Guerrero, México</li>
                    <li>1994 San Juan de Puerto Rico, Puerto Rico</li>
                    <li>1994 Publicación de obra pictórica en billetes de la Lotería Nacional</li>
                    <li>1995 Publicación de obra pictórica en billetes de la Lotería Nacional</li>
                    <li>1996 Instituto Mexicano del Petróleo. México, D.F.</li>
                    <li>1996 Presentación del video “Vida de Merino”. México, D.F.</li>
                    <li>1997 Presentación de video A Través de los Dogmas, Recopilación pictórica. México. D.F.</li>
                    <li>2001 “Levitan el ser y el ego a la orilla de lo divino”, Salón de la Plástica Mexicana, Colima. Col Roma</li>
                    <li>2001 Exposición Metro candelaría, Ciudad de México</li>
                    <li>2002 UPICSA (IPN, Instituto Politécnico Nacional).</li>
                    <li>2005 Museo Felipe Santiago, Toluca, Estado de México.</li>
                    <li>2006 Museo Adolfo López Mateos, Atizapán, Estado de México.</li>
                    <li>2010 Casa de Cultura Tepeji del Rio, Hidalgo.</li>
                    <li>2010 Universidad Tecnológica, Tula – Tepeji, Hidalgo.</li>
                    <li>2016 Museo Felipe Santiago, Toluca, Estado de México.</li>
                    <li>2016 Fundución corporativa Pascual, Cuidad de México.</li>
                    <li>2018 Casa de Cultura de Ixtlahuaca, Estado de México.</li>
                    <li>2018 Galería 70, Ciudad de México.</li>
                    <li>2019 Centro Cultural de las Artes “Jose Emilio Pacheco”, Tlalnepantla, Estado de México.</li>
                </ul>
            </div>
            <div className='Incisos'>
                <br />
                <h3>Exposiciones Individuales</h3>
                <br />
                <ul>
                    <li>1965 Galería de Arte de México. Ciudad de México.</li>
                    <li>1966 Galería de Arte de México. Ciudad de México.</li>
                    <li>1976 Galería Ling’s Cobre, Ciudad de México.</li>
                    <li>1977 Salón del Periodista México, Ciudad de México.</li>
                    <li>1977 Galería del escultor Jorge Alarcón México, Ciudad de México.</li>
                    <li>1983 Galería José Ma. Velasco México, Ciudad de México.</li>
                    <li>1984 Narth Nude. Vancouver, BC. Canadá</li>
                    <li>1984 Nouveau Nude. Vancouver, BC. Canadá</li>
                    <li>1984 Galería Artdicre. México, D.F.</li>
                    <li>1986 Feria del Arte Colegio Americano, Ciudad de México.</li>
                    <li>1987 Feria del Arte Colegio Americano, Ciudad de México.</li>
                    <li>1988 Feria del Arte Colegio Americano. Ciudad de México.</li>
                    <li>1988 Galería Romano, Ciudad de México.</li>
                    <li>1988 Hotel Holiday Inn Crowne Plaza, Ciudad de México.</li>
                    <li>1988 Galería José Ma. Velasco, Ciudad de México.</li>
                    <li>1988 Galería Orsay, Ciudad de México.</li>
                    <li>1989 Galería José Ma. Velasco, Ciudad de México.</li>
                    <li>1990 Cámara Nacional de la Panadería, Ciudad de México.</li>
                    <li>1990 Galería Torre Pedro Domecq, Ciudad de México.</li>
                    <li>1993 Galería Misrachi, Ciudad de México.</li>
                    <li>1995 Colegio Irlandés, Ciudad de México.</li>
                    <li>1995 Museo de Bellas Artes de Toluca, Estado de México</li>
                    <li>1997 Instituto Politécnico Nacional UPICSA, Ciudad de México.</li>
                    <li>1997 Clínica ISSSTE, Tlatelolco, Ciudad de México.</li>
                    <li>1998 Galería balance, Ciudad de México.</li>
                    <li>1998 CENSODEP, Ciudad de México.</li>
                    <li>1998 Congreso de Asambleístas Plaza de la Constitución, Ciudad de México.</li>
                    <li>1998 Galería Coral & Marina, Ensenada Baja California, México</li>
                    <li>1999 Galería “El Ángel” Zona Rosa, Ciudad de México.</li>
                    <li>2000 Museo Adolfo López Mateos Atizapán de Zaragoza, Estado de México.</li>
                    <li>2000 Plaza Satélite Naucalpan Estado de México</li>
                    <li>2000 Exposición e ingreso al Salón de la Plástica Mexicana, Ciudad de México.</li>
                    <li>2000 Salón de la Plástica, Centro Histórico, Ciudad de México.</li>
                    <li>2000 Salón de la Plástica. col. Roma, Ciudad de México.</li>
                    <li>2001 “Levitan el Ser y el Ego”, Salón de la Plástica Mexicana (Colima 196, Roma, Ciudad de México.) </li>
                    <li>2001 Auditorio María Raña de Vázquez, Hospital Ángeles del Pedregal, Ciudad de México.</li>
                    <li>2003 Museo Adolfo López Mateos, Atizapán Estado de México.</li>
                    <li>2004 Galería siglo XXI, Centro Medico del Seguro Social, Ciudad de México.</li>
                    <li>2005 al 2020 Hospital Ángeles “Interlomas” Estado de México.</li>
                    <li>2001 al 2020 Salón de la Plástica Mexicana, Ciudad de México.</li>
                    <li>2014 Museo “José María Velasco” Toluca, Estado de México.</li>
                    <li>2022 Museo de historia, Atlacomulco, Estado de México.</li>
                    <li>2022 Universidad de Ixtlahuaca (CUI), Estado de México.</li>
                </ul>
                <br />
                <br />
            </div>
        </div>
    );
}